export default __webpack_public_path__ + "static/media/jnh8.47ed3b5f.jpg";